var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowTopLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2.25C2.58579 2.25 2.25 2.58579 2.25 3V17.4C2.25 17.7033 2.43273 17.9768 2.71299 18.0929C2.99324 18.209 3.31583 18.1448 3.53033 17.9303L10.2 11.2607L20.4697 21.5303C20.7626 21.8232 21.2374 21.8232 21.5303 21.5303C21.8232 21.2374 21.8232 20.7626 21.5303 20.4697L11.2607 10.2L17.9303 3.53033C18.1448 3.31583 18.209 2.99324 18.0929 2.71299C17.9768 2.43273 17.7033 2.25 17.4 2.25H3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTopLeft);
export default __webpack_public_path__ + "static/media/arrow-top-left.4e4bc5c518caae2f6f598d45bb74e049.svg";
export { ForwardRef as ReactComponent };